import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { propBool, propShape, propStr, } from '../../../helpers/custom-prop-types';
import { textPrice } from '../../../helpers/solution';
const BalloonCategoryPrice = ({ isInline, isOneElement, item, periodClassName, priceClassName, showPeriod, showPrice, showTheme, themeClassName, wrappedClassName, }) => {
    const solutionMiddleClass = item.solutionMiddleClass || {};
    const checkShowTheme = showTheme && !!(solutionMiddleClass && solutionMiddleClass.name);
    const checkShowPrice = showPrice && item.price;
    const checkShowPeriod = showPeriod && item.period;
    if (checkShowTheme || checkShowPrice || showPeriod) {
        const WrapperElement = isInline || isOneElement ? 'span' : 'div';
        const partsList = [];
        if (checkShowTheme) {
            if (isOneElement) {
                partsList.push(solutionMiddleClass.name);
            }
            else {
                partsList.push(_jsx("span", Object.assign({ className: themeClassName }, { children: solutionMiddleClass.name })));
            }
        }
        if (checkShowPrice) {
            if (isOneElement) {
                partsList.push(textPrice(item.price));
            }
            else {
                partsList.push(_jsx("span", Object.assign({ className: priceClassName }, { children: textPrice(item.price) })));
            }
        }
        if (checkShowPeriod) {
            if (isOneElement) {
                partsList.push(`${item.period} 週間`);
            }
            else {
                partsList.push(_jsx("span", Object.assign({ className: periodClassName }, { children: `${item.period} 週間` })));
            }
        }
        const viewParts = partsList
            .filter((partsItem) => !!partsItem)
            .map((partsItem, index) => ({
            id: index,
            partsItem,
        }));
        return (_jsx(WrapperElement, Object.assign({ className: wrappedClassName }, { children: viewParts.map(({ id, partsItem }) => (_jsxs(Fragment, { children: [partsItem, id !== viewParts.length - 1 && ' / '] }, id))) })));
    }
    return null;
};
BalloonCategoryPrice.propTypes = {
    isInline: propBool(),
    isOneElement: propBool(),
    item: propShape().isRequired,
    periodClassName: propStr(),
    priceClassName: propStr(),
    showPeriod: propBool(),
    showPrice: propBool(),
    showTheme: propBool(),
    themeClassName: propStr(),
    wrappedClassName: propStr(),
};
BalloonCategoryPrice.defaultProps = {
    isInline: false,
    isOneElement: false,
    periodClassName: '',
    priceClassName: '',
    showPeriod: true,
    showPrice: true,
    showTheme: false,
    themeClassName: '',
    wrappedClassName: '',
};
export default BalloonCategoryPrice;
